// extracted by css-extract-rspack-plugin
var _1 = "fSPRjQtDO06g929rGmhvwQ--";
var _2 = "_4F28r-ev2K14Gu6hLObv2g--";
export { _1 as "loading", _2 as "spinAnimation" }
